export const radii = {
  0: '4px',
  1: '8px',
  2: '12px',
  rounded: '999px',
};
